import { OutlinedVideoIcon } from '@/components/elements/svgIcon/outlined';
import { removeQueryStringInS3Link } from '@/helpers/s3Helpers';
import { useScreen } from '@/hooks/useScreen';
import useToggle from '@/hooks/useToggle';
import { Box, Modal } from '@mui/material';
import { ComponentPropsWithoutRef } from 'react';

type EnterpriseBaseVideoProps = ComponentPropsWithoutRef<'div'> & {
  thumbnail: string | null;
  videoUrl: string;
};

const EnterpriseBaseVideo = (props: EnterpriseBaseVideoProps) => {
  const { thumbnail, videoUrl, className, ...restProps } = props;
  const [openModal, onToggleModal] = useToggle();
  const { isDesktop } = useScreen();

  const onPlay = () => {
    if (!videoUrl) return;
    onToggleModal();
  };

  return (
    <>
      <div
        {...restProps}
        onClick={onPlay}
        className={`relative flex-1 cursor-pointer ${className}`}
      >
        <OutlinedVideoIcon className="absolute inset-0 z-10 m-auto text-white" />
        {thumbnail ? (
          <img
            src={removeQueryStringInS3Link(thumbnail)}
            alt="thumbnail"
            className="h-full w-full object-cover"
          />
        ) : (
          <video
            src={removeQueryStringInS3Link(videoUrl)}
            className="h-full w-full object-cover"
          />
        )}
      </div>

      <Modal open={openModal} onClose={onToggleModal}>
        <Box
          className={`absolute inset-0 m-auto w-[80vw] ${
            isDesktop ? 'h-[80dvh]' : 'h-[30dvh]'
          }`}
        >
          <video
            src={removeQueryStringInS3Link(videoUrl)}
            controls
            className="h-full w-full"
          />
        </Box>
      </Modal>
    </>
  );
};

export default EnterpriseBaseVideo;
